import { Component, HostListener } from '@angular/core';
import { AnalyticsService } from 'src/app/helpers/analytics.service';
import { Platform } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { Storage } from '@ionic/storage'
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  providers: [AnalyticsService],
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  checkOnce: boolean;
  urlParameter: any;
  userIdValue: any;
  tokenValue: any;
  mobileNo: any;
  text: any;
  display: boolean = true;
  constructor(private analytics: AnalyticsService, private platform: Platform, private route: ActivatedRoute, private storage: Storage, private router: Router) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.analytics.init();
      this.storage.get('token').then((response) => {
        this.storage.get('role').then((role) => {
          console.log(response)
          console.log(window.location.pathname);
          //For Influncer
          if (response != null && role == "user") {
            let pathValue = window.location.pathname.split('/')[2];
            if (pathValue == 'leads') {
              this.router.navigate(['influencer/' + pathValue + '/generated']);
            }
            else {
              pathValue = pathValue == undefined ? 'dashboard' : window.location.pathname.split('/')[2];
              this.router.navigate(['influencer/' + pathValue]);
            }
          }
           //For Admin
          if (response != null && role == "admin") {
            let pathValue = window.location.pathname.split('/')[2];
            pathValue = pathValue == undefined ? 'dashboard' : window.location.pathname.split('/')[2];
            this.router.navigate(['admin/' + pathValue]);
          }
          if (response === null && role == null) {
            console.log(window.location.pathname);
            if (window.location.pathname === '/login/admin') {
              this.router.navigate(['login/admin']);
            }
            else {
              this.router.navigate(['login']);
            }
          }
        })
      })
    })
  }
}
